import React from "react"
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Dimensions
} from "react-native"

interface Props {
  title: string
  address: string
  onComplete: () => void
  themeColor?: string
  type?: string
  status?: string

}

const ProjectHeaderCard: React.FC<Props> = ({
  title,
  address,
  onComplete,
  themeColor = "#2563EB", // default primary,
  type,
  status
}) => {

  const isMobile = Dimensions.get("window").width < 768

  return (
    <View style={styles.card}>

      {/* LEFT CONTENT */}
      <View style={{ flex: 1 }}>
        <Text
          style={[
            styles.title,
            { color: themeColor }
          ]}
          numberOfLines={2}
        >
          {title} ({address})
        </Text>
      </View>

      {/* RIGHT ACTION */}
     
     
     <View style={[styles.actionWrapper, isMobile && { marginTop: 16 }]}>
       {type=="archived"?
      <TouchableOpacity
        onPress={onComplete}
        style={styles.completeButton}
        disabled={true}
      >
        <Text style={styles.completeText}>
        {status ?status.toUpperCase():"-"}
        </Text>
      </TouchableOpacity>: <TouchableOpacity
          onPress={onComplete}
          style={styles.completeButton}
          disabled={type=="completed"}
        >
          <Text style={styles.completeText}>
          {type=="completed"?"COMPLETED": "Mark Project as Completed"}
          </Text>
        </TouchableOpacity>}
      </View>

    </View>
  )
}

export default ProjectHeaderCard

/* ================= STYLES ================= */

const styles = StyleSheet.create({

  card: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 20,
    marginTop: 20,

    /* Shadow for iOS */
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 10,

    /* Shadow for Android */
    elevation: 4,

    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },

  title: {
    fontSize: 18,
    fontWeight: "700",
    textTransform: "capitalize",
  },

  actionWrapper: {
    justifyContent: "center",
  },

  completeButton: {
    backgroundColor: "#16A34A", // success color
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 30,
  },

  completeText: {
    color: "#fff",
    fontWeight: "600",
    fontSize: 14,
  },

})
